/*
 * 减免开卡
 *
 * *
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { ReduceCreditCardFeeReq} from "@/pbjs/xcommon/collection_pb";
import InnerRequest from "./request";
export interface Options {
    // CommonIn?: string;
    OrderId?: string;
    // CardFee?: string;
}
export function setReduceCreditCardFeeReq(arg: Options) {
    let request: any = new ReduceCreditCardFeeReq();
    // request.setCommonIn(arg.CommonIn);
    request.setOrderid(arg.OrderId);
    // request.setCardFee(arg.CardFee);
    return request;
}
export const getReduceCreditCardFeeRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.reduceCreditCardFee
);